<template>
  <div style="height: 100%">
    <el-table
      :data="tableData"
      height="100%"
      :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    >
      <el-table-column
        prop="business_name"
        align="center"
        min-width="120"
        label="集配中心"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="supplier_order_no"
        align="center"
        min-width="120"
        label="供货单编号"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="supplier_name" align="center" label="供应商名称">
      </el-table-column>
      <el-table-column prop="buyer_name" align="center" label="业务名称">
      </el-table-column>
      <el-table-column prop="sku_code" align="center" label="商品名称（货号）">
        <template slot-scope="scope">
          <div>{{ scope.row.title }}({{ scope.row.sku_code }})</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        align="center"
        label="创建时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="product_amt"
        align="center"
        label="商品总金额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="qc_out_amt"
        align="center"
        label="复核缺货金额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="aftersale_amt"
        align="center"
        label="供应商售后扣款金额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="tdc_settle_status"
        align="center"
        label="结算状态"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.tdc_settle_status == 1 ? "已结算" : "未结算" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="tdc_settle_time"
        align="center"
        label="结算日期"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="financial_fee"
        align="center"
        label="金融手续费(0.4%)"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="service_charges_fee"
        align="center"
        label="应收推广奖励"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="service_charges_fee_real"
        align="center"
        label="实际推广奖励"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="service_charges_fee_diff"
        align="center"
        label="差额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="settlement_amt"
        align="center"
        label="结算金额"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column
        prop="purchase_deduction_amount"
        align="center"
        label="操作"
        fixed="right"
      >
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="handleDetail(scope.row)">
              查看详情
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "TableList",
  props: ["tableData"],
  data() {
    return {};
  },
  mounted() {},
  watch: {},

  methods: {
    handleDetail(row) {
      this.$router.push({
        path: `/reward-settlement-detail`,
        query: {
          supplier_order_no: row.supplier_order_no,
          sku_code: row.sku_code,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
